/**
 * Retired "back to live stream" button.
 *
 * AppContainer mounts the live page as a full-screen overlay whenever a
 * stream is active, whatever the URL, so there is never a hidden stream to
 * return to. The old floating button only sat underneath that overlay and
 * flashed through while the window was resized. Remove the <BackToStream />
 * mount in AppContainer next time that file is edited.
 */
export default function BackToStream() {
  return null;
}
